module.exports = __webpack_public_path__ + "static/media/F10.24164995.jpg";